import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpObserve } from '@angular/common/http/src/client';
import {ClientRequestMethod, ResponseContentType} from '../enums/client-request-method.enum';

export class ClientRequestOptions {

  method: ClientRequestMethod;
  headers: HttpHeaders;
  body: any;
  url: string | null;
  params: HttpParams;
  search: URLSearchParams;
  observe?: HttpObserve;
  redentials?: boolean;
  withCredentials: boolean;
  responseType?: ResponseContentType;

  constructor() {
  };

}
